(function($) {
  'use strict';

  var giftProperty = '_xo_free_gift';
  var isSyncingGift = false;
  var rewardRefreshTimer;

  function giftLines(cart) {
    return (cart.items || []).filter(function(item) {
      return item.properties && String(item.properties[giftProperty]) === 'true';
    });
  }

  function qualifyingTotal(cart) {
    return (cart.items || []).reduce(function(total, item) {
      return total + (item.properties && String(item.properties[giftProperty]) === 'true'
        ? 0
        : (item.final_line_price != null ? item.final_line_price : item.line_price));
    }, 0);
  }

  function money(cents) {
    var format = window.theme && theme.settings ? theme.settings.moneyFormat : '';

    if (window.slate && slate.Currency && typeof format === 'string' && format.indexOf('{{') !== -1) {
      try {
        return slate.Currency.formatMoney(cents, format);
      } catch (error) {
        // Fall through to the store's dollar display below.
      }
    }

    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function setGiftStatus(message, isError) {
    $('.xo-rewards__gift-status')
      .text(message)
      .toggleClass('is-error', !!isError)
      .attr('aria-hidden', message ? 'false' : 'true');
  }

  function setGiftButtonsLoading(isLoading) {
    $('.xo-rewards__gift').each(function() {
      var $gift = $(this);
      var unavailable = $gift.attr('data-available') === 'false';

      $gift
        .toggleClass('is-loading', isLoading)
        .prop('disabled', isLoading || unavailable)
        .attr('aria-busy', isLoading ? 'true' : 'false');
    });
  }

  function decorateGiftLine(cart) {
    var lines = giftLines(cart);

    $('.xo-free-gift-line').removeClass('xo-free-gift-line');
    $('.xo-free-gift-line__badge').remove();

    lines.forEach(function(item) {
      var line = (cart.items || []).indexOf(item) + 1;
      var $row = $('.cart-drawer .ajaxcart__row[data-line="' + line + '"]');
      var $product = $row.closest('.ajaxcart__product');

      if (!$row.length) return;

      $product.addClass('xo-free-gift-line');
      $row.find('.ajaxcart__product-name').after('<span class="xo-free-gift-line__badge">FREE GIFT</span>');

      if (item.final_line_price === 0) {
        $row.find('.priceWrapper').html(
          '<s>' + money(item.original_line_price) + '</s>' +
          '<span class="xo-free-gift-line__price">FREE</span>'
        );
      }
    });
  }

  function removeGiftLines(lines, callback) {
    var queue = lines.slice();

    function removeNext() {
      var item = queue.shift();

      if (!item) {
        callback();
        return;
      }

      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: { id: item.key, quantity: 0 },
        dataType: 'json'
      }).always(removeNext);
    }

    removeNext();
  }

  function reloadDrawer() {
    if (window.ajaxCart && typeof ajaxCart.load === 'function') {
      ajaxCart.load();
    }
  }

  function normalizeGift(cart, giftThreshold) {
    var lines = giftLines(cart);
    var subtotal = qualifyingTotal(cart);
    var needsRemoval = subtotal < giftThreshold;
    var extras = lines.slice(1);
    var paidGift = lines.some(function(item) {
      return item.final_line_price > 0;
    });

    if (isSyncingGift || !lines.length) return false;

    if (needsRemoval || paidGift) {
      isSyncingGift = true;
      removeGiftLines(lines, function() {
        isSyncingGift = false;
        reloadDrawer();
        setGiftStatus(
          needsRemoval ? 'Add $' + Math.ceil((giftThreshold - subtotal) / 100) + ' more to choose a free gift.' : 'The gift discount could not be applied. Please try again.',
          paidGift && !needsRemoval
        );
      });
      return true;
    }

    if (lines[0].quantity !== 1 || extras.length) {
      isSyncingGift = true;
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: { id: lines[0].key, quantity: 1 },
        dataType: 'json'
      }).always(function() {
        removeGiftLines(extras, function() {
          isSyncingGift = false;
          reloadDrawer();
        });
      });
      return true;
    }

    return false;
  }

  function renderRewards(cart) {
    var $rewards = $('.xo-rewards');
    if (!$rewards.length || !cart) return;

    var $wrapper = $rewards.find('.fs-bar-wrapper');
    var giftThreshold = parseInt($rewards.attr('data-xo-gift-threshold'), 10) || 6500;
    var shippingThreshold = parseInt($rewards.attr('data-xo-shipping-threshold'), 10) || 7500;
    var subtotal = qualifyingTotal(cart);
    var giftRemaining = Math.max(0, giftThreshold - subtotal);
    var shippingRemaining = Math.max(0, shippingThreshold - subtotal);
    var selectedLines = giftLines(cart);
    var progress;

    if (normalizeGift(cart, giftThreshold)) return;

    if (subtotal >= shippingThreshold) {
      progress = 100;
    } else if (subtotal >= giftThreshold) {
      progress = 70 + ((subtotal - giftThreshold) / (shippingThreshold - giftThreshold)) * 30;
    } else {
      progress = (subtotal / giftThreshold) * 70;
    }
    progress = Math.min(100, Math.max(0, progress));

    $rewards.find('.fs-bar-filler').width(progress + '%');
    $wrapper.toggleClass('gift-unlocked', subtotal >= giftThreshold);
    $wrapper.toggleClass('unlocked', subtotal >= shippingThreshold);

    $rewards.find('#fs-bar-message').prop('hidden', subtotal >= shippingThreshold);
    if (subtotal >= shippingThreshold) {
      $rewards.find('#fs-bar-message').empty();
    } else if (subtotal >= giftThreshold) {
      $rewards.find('#fs-bar-message').html('<strong>Free gift unlocked!</strong><br><span>' + money(shippingRemaining) + ' away from free 2-day shipping</span>');
    } else {
      $rewards.find('#fs-bar-message').html('<strong>' + money(giftRemaining) + ' away</strong> from a free gift<br><span>' + money(shippingRemaining) + ' away from free 2-day shipping</span>');
    }

    $rewards.find('.xo-rewards__gifts')
      .attr('aria-hidden', subtotal < giftThreshold ? 'true' : 'false');

    $rewards.find('.xo-rewards__gift').removeClass('is-selected').attr('aria-pressed', 'false');

    if (selectedLines.length) {
      var variantId = String(selectedLines[0].variant_id);
      var $selected = $rewards.find('.xo-rewards__gift[data-variant-id="' + variantId + '"]');
      $selected.addClass('is-selected').attr('aria-pressed', 'true');
      setGiftStatus('', false);
    } else if (subtotal >= giftThreshold) {
      setGiftStatus('', false);
    }

    decorateGiftLine(cart);
    setGiftButtonsLoading(false);
  }

  function loadRewards() {
    window.clearTimeout(rewardRefreshTimer);
    rewardRefreshTimer = window.setTimeout(function() {
      $.getJSON('/cart.js', renderRewards);
    }, 0);
  }

  function addGift($gift) {
    var variantId = parseInt($gift.attr('data-variant-id'), 10);
    var giftName = $gift.attr('data-gift');
    var $rewards = $gift.closest('.xo-rewards');
    var giftThreshold = parseInt($rewards.attr('data-xo-gift-threshold'), 10) || 6500;

    if (!variantId || isSyncingGift) return;

    isSyncingGift = true;
    setGiftButtonsLoading(true);
    setGiftStatus('Adding ' + giftName + '...', false);

    $.getJSON('/cart.js', function(cart) {
      var subtotal = qualifyingTotal(cart);
      var existing = giftLines(cart);
      var sameGift = existing.length === 1 && String(existing[0].variant_id) === String(variantId) && existing[0].quantity === 1;

      if (subtotal < giftThreshold) {
        isSyncingGift = false;
        setGiftButtonsLoading(false);
        setGiftStatus('Add $' + Math.ceil((giftThreshold - subtotal) / 100) + ' more to choose a free gift.', true);
        return;
      }

      if (sameGift) {
        isSyncingGift = false;
        setGiftButtonsLoading(false);
        renderRewards(cart);
        return;
      }

      removeGiftLines(existing, function() {
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            id: variantId,
            quantity: 1,
            properties: { _xo_free_gift: 'true' }
          },
          dataType: 'json',
          success: function() {
            setGiftStatus('', false);
          },
          error: function() {
            setGiftStatus('That gift is unavailable. Please choose another.', true);
          },
          complete: function() {
            isSyncingGift = false;
            reloadDrawer();
            loadRewards();
          }
        });
      });
    }).fail(function() {
      isSyncingGift = false;
      setGiftButtonsLoading(false);
      setGiftStatus('We could not update your gift. Please try again.', true);
    });
  }

  var isUpdatingMobileCart = false;

  function handleMobileCartControl(event) {
    if (document.querySelector('.cart-drawer[data-wholesale-cart="true"]')) return;
    if (!window.matchMedia('(max-width: 767px)').matches) return;

    var $control = $(event.target).closest('.ajaxcart__qty-adjust');
    if (!$control.length) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (isUpdatingMobileCart) return;

    var $row = $control.closest('.ajaxcart__row');
    var $quantity = $row.find('.ajaxcart__qty-num').first();
    var line = parseInt($control.attr('data-line'), 10);
    var quantity = parseInt($quantity.val(), 10) || 0;

    if (!line) return;

    if ($control.hasClass('ajaxcart__qty--remove')) {
      quantity = 0;
    } else if ($control.hasClass('ajaxcart__qty--plus')) {
      quantity += 1;
    } else {
      quantity = Math.max(0, quantity - 1);
    }

    isUpdatingMobileCart = true;
    if ($control.closest('[data-wholesale-cart="true"]').length && !$control.hasClass('ajaxcart__qty--remove')) {
      quantity = Math.max(5, quantity);
    }
    $row.addClass('is-loading');

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: { line: line, quantity: quantity },
      dataType: 'json'
    }).always(function() {
      isUpdatingMobileCart = false;
      reloadDrawer();
    });
  }

  document.addEventListener('click', handleMobileCartControl, true);

  $(document.body)
    .on('ajaxCart.afterCartLoad', loadRewards)
    .on('click', '.xo-rewards__gift', function() {
      addGift($(this));
    });

  $(loadRewards);
})(jQuery);
